
(function inicioModuleDefinition() {

    'use strict';

    angular.module('Inicio', ['ui.router', 'ui.bootstrap.carousel', 'Config', 'Entities', 'Messages'])
        .config([
            'configProvider', '$stateProvider',
            function inicioConfig(config, $stateProvider) {

                $stateProvider.state('inicio', {
                    url: "/",
                    templateUrl: config.resourceUrl('/views/inicio/inicio.html'),
                    controller: 'InicioController'
                });

                $stateProvider.state('login', {
                    url: "/login?confirmed",
                    templateUrl: config.resourceUrl('/views/inicio/inicio.html'),
                    controller: 'InicioController'
                });

                $stateProvider.state('inicio-changeuser', {
                    url: "/{key}",
                    templateUrl: config.resourceUrl('/views/inicio/inicio.html'),
                    controller: 'InicioController'
                });

                $stateProvider.state('inicio-ou-document-detail', {
                    url: '/Ou/{ouId}/Document/Detail/{id}',
                    templateUrl: config.resourceUrl('/views/inicio/inicio.html'),
                    controller: 'InicioOuController',
                    authorize: true,
                    resolve: {
                        urlstate: function () {
                            return 'document-detail';
                        }
                    },
                });

                $stateProvider.state('inicio-ou-mydocument-detail', {
                    url: '/Ou/{ouId}/MyDocument/Detail/{id}',
                    templateUrl: config.resourceUrl('/views/inicio/inicio.html'),
                    controller: 'InicioOuController',
                    authorize: true,
                    resolve: {
                        urlstate: function () {
                            return 'mydocument-detail';
                        }
                    },
                });
            }
        ]);
})();